export var hasDepsChanged = function hasDepsChanged(dep1, dep2) {
  return !dep1 || !dep2 || dep1.length !== dep2.length || !dep1.every(function (v1, i) {
    return dep2[i] === v1;
  });
};